import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 0,
  class: "nr-modal__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrButton = _resolveComponent("NrButton")!
  const _component_NrIconButton = _resolveComponent("NrIconButton")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "modal",
        id: _ctx.id,
        class: "nr-modal",
        "aria-hidden": "true"
      }, [
        _createElementVNode("div", {
          class: "nr-modal__overlay",
          tabindex: "-1",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleOverlayClick && _ctx.handleOverlayClick(...args))),
          ref: "overlay"
        }, [
          _createElementVNode("div", {
            role: "dialog",
            "aria-modal": "true",
            "aria-label": _ctx.title,
            class: _normalizeClass(_ctx.modalClassnames)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([
            'nr-modal__header',
            {
              'nr-modal__header--hidden-footer':
                !_ctx.showFooter && _ctx.type !== 'warning'
            },
            { 'nr-modal__header-warning': _ctx.type === 'warning' }
          ])
            }, [
              _renderSlot(_ctx.$slots, "header", {}, () => [
                _createElementVNode("h2", {
                  class: _normalizeClass([
                'nr-modal__title',
                {
                  'nr-modal__title--hidden-footer': !_ctx.showFooter
                }
              ])
                }, _toDisplayString(_ctx.title), 3)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.modalContentClassnames),
              id: `${_ctx.id}__content`,
              ref: "modal-content",
              tabindex: "0"
            }, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode("Modal content goes here")
              ])
            ], 10, _hoisted_3),
            (_ctx.showFooter)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.hasSecondaryButton)
                    ? (_openBlock(), _createBlock(_component_NrButton, {
                        key: 0,
                        onClick: _ctx.handleSecondaryClick,
                        variant: "bordered-primary",
                        "aria-label": _ctx.secondaryButtonText
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.secondaryButtonText), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "aria-label"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_NrButton, {
                    onClick: _ctx.handlePrimaryClick,
                    "aria-label": _ctx.primaryButtonText,
                    disabled: _ctx.disableButtons
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.primaryButtonText), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "aria-label", "disabled"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showClose)
              ? (_openBlock(), _createBlock(_component_NrIconButton, {
                  key: 1,
                  class: "nr-modal__close",
                  variant: "minimal-neutral",
                  size: "small",
                  icon: { name: 'times', type: 'regular' },
                  "aria-label": "Close modal",
                  onClick: _ctx.handleCloseClick
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_2)
        ], 512)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}